import { Divider, Grid, Tab, Tabs, styled } from "@mui/material";
import { useEffect } from "react";

import BoxFixedYearlyProfit from "./Component/BoxFixedYearlyProfit";
import BoxProofWork from "./Component/BoxProofWork";
import { VALUE_INVESTMENT_FUND } from "pages/Wallet/constants";
import { getInvestmentBuyList } from "store/slices/investment/investmentSlice";
import useDispatch from "hooks/useDispatch";
import { useSelector } from "react-redux";
import ComingSoon from "components/ComingSoon";
import { useSearchParams } from "react-router-dom";

const dataTabs = [
  { id: 1, name: "Investment Fund" },
  { id: 2, name: "Investment Fixed" },
];

function CreateInvestmentFund() {
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams()
  const investmentTabForm = +searchParams.get("investmentTabForm") || 1

  const investmentList = useSelector(
    (state) => state.investment.investmentBuyList?.data
  );

  const handleChangeTab = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      investmentTabForm: newValue,
      investmentTab: newValue,
    });
  };

  useEffect(() => {
    dispatch(getInvestmentBuyList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (

    <Grid container spacing={1}>
      <Grid item xs={12}>
        <TabsStyle value={investmentTabForm} onChange={handleChangeTab}>
          {dataTabs?.map((data) => (
            <Tab value={data.id} label={data.name} />
          ))}
        </TabsStyle>
      </Grid>

      <Grid item xs={12}>
        {investmentTabForm === VALUE_INVESTMENT_FUND.All && (
            <>
              <BoxProofWork
                investmentTabForm={investmentTabForm}
              />

              <Divider width={"100%"} />

              <BoxFixedYearlyProfit
                investmentTabForm={investmentTabForm}
              />
            </>
          )}


        {investmentTabForm === VALUE_INVESTMENT_FUND.Fixed && (
          <BoxFixedYearlyProfit
            investmentTabForm={investmentTabForm}
            investmentDetail={investmentList?.filter((item) => item.typeId === VALUE_INVESTMENT_FUND.Fixed)}
          />
          // <ComingSoon />
        )}

        {(investmentTabForm === VALUE_INVESTMENT_FUND.Floating || investmentTabForm === VALUE_INVESTMENT_FUND.All) && (
          <>
            {investmentList?.filter((item) => item.typeId === VALUE_INVESTMENT_FUND.Floating)?.map((investmentDetail) => (
              <BoxProofWork
                investmentDetail={investmentDetail}
              />
            ))}
          </>
        )}
      </Grid>
    </Grid>

  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  marginTop: theme.spacing(3),
  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default CreateInvestmentFund;
